import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Truck, ShieldCheck } from 'lucide-react';
export function StickyCartBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 600px (approx hero height)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 py-3 px-4 md:py-4 animate-in slide-in-from-bottom duration-300" data-id="element-305">
      <div className="container mx-auto flex items-center justify-between max-w-5xl" data-id="element-306">
        <div className="hidden md:flex flex-col" data-id="element-307">
          <span className="font-bold text-gray-900 text-lg" data-id="element-308">
            Dentafix™ 3-Pack — $59.95
          </span>
          <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-309">
            <span className="flex items-center gap-1" data-id="element-310">
              <Truck className="w-3 h-3" data-id="element-311" /> Free Shipping
            </span>
            <span className="flex items-center gap-1" data-id="element-312">
              <ShieldCheck className="w-3 h-3" data-id="element-313" /> 90-Day Smile Guarantee
            </span>
          </div>
        </div>

        <div className="md:hidden" data-id="element-314">
          <span className="font-bold text-gray-900 block" data-id="element-315">$59.95</span>
          <span className="text-xs text-green-600 font-medium" data-id="element-316">
            Free Shipping
          </span>
        </div>

        <CTAButton text="Claim Offer" size="lg" className="py-2 px-6 text-base md:py-3 md:px-8" onClick={() => document.getElementById('offers')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-317" />
      </div>
    </div>;
}